// extracted by mini-css-extract-plugin
export default {"PointerBox":"CopilotPopover-module__PointerBox--J7KPP"};